import Pusher from 'pusher-js'

window.Pusher = Pusher

/**
 * A conexão guarda o token com que foi criada. Trocar de sessão (login, logout,
 * renovação) deixava o cabeçalho antigo preso na instância, porque ela só era
 * montada uma vez — e todo canal privado passava a levar 401 para sempre.
 */
function atualizarToken(conexao, token) {
  if (!conexao?.config?.auth?.headers) return

  conexao.config.auth.headers.Authorization = `Bearer ${token}`
}

export function createSocketConnection(token) {
  // if (window.location.origin === process.env.REACT_APP_LIBERTA_URL) {
  //   return
  // }
  if (window.PusherEcho) {
    atualizarToken(window.PusherEcho, token)

    return
  }

  if (!window.PusherEcho) {
    window.PusherEcho = new Pusher(process.env.REACT_APP_SOCKET_KEY, {
      wsHost: process.env.REACT_APP_WS_HOST,
      wsPort: process.env.REACT_APP_WS_PORT,
      wssPort: process.env.REACT_APP_WS_PORT,
      authEndpoint: `${process.env.REACT_APP_API_URL}/api/broadcasting/auth`,
      forceTLS: true,
      enabledTransports: ['ws', 'wss'],
      auth: {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json"
        }
      }
    })
  }
}

export function createChatSocketConnection(token) {
  // if (window.location.origin === process.env.REACT_APP_LIBERTA_URL) {
  //   return
  // }
  if (window.PusherEchoChat) {
    atualizarToken(window.PusherEchoChat, token)

    return
  }

  if (!window.PusherEchoChat) {
    window.PusherEchoChat = new Pusher(process.env.REACT_APP_SOCKET_KEY, {
      wsHost: process.env.REACT_APP_CHAT_HOST,
      wsPort: process.env.REACT_APP_CHAT_PORT,
      wssPort: process.env.REACT_APP_CHAT_PORT,
      authEndpoint: `${process.env.REACT_APP_CHAT_API_URL}/api/broadcasting/auth`,
      forceTLS: true,
      enabledTransports: ['ws', 'wss'],
      auth: {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json"
        }
      }
    })
  }
}
